import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=149d639e&scoped=true"
import script from "../js/ResetPassword/index.js?vue&type=script&lang=js&external"
export * from "../js/ResetPassword/index.js?vue&type=script&lang=js&external"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=149d639e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d639e",
  null
  
)

export default component.exports